import { Outlet } from "react-router-dom";
import { HelpCircle } from "lucide-react";

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-muted/30 p-4">
      <div className="mb-8 flex items-center gap-2">
        <HelpCircle className="h-8 w-8 text-primary" />
        <span className="text-2xl font-semibold text-foreground">
          Support Portal
        </span>
      </div>
      <div className="w-full max-w-sm">
        <Outlet />
      </div>
    </div>
  );
}
